import { matchPath } from 'react-router-dom';

export const APP_TITLE = 'COMS';
const SEPARATOR = ' · ';
const MAX_DETAIL = 60;

const TASKS = ['Tasks'];
const TALENTS = ['Talents'];
const BOARDING = ['On/Off-boarding'];
const TALENT_PORTAL = '/talent';
const CUSTOMER_PORTAL = '/customer';

// Ordered, most specific first. Crumbs are most specific first.
const SECTIONS = [
  // Tasks (the list lives under /tasks/new; /tasks/* children are matched with and without that prefix)
  ...['/tasks', '/tasks/new'].flatMap(base => [
    { pattern: `${base}/inbox`, title: ['Inbox', ...TASKS] },
    { pattern: `${base}/create`, title: ['New task', ...TASKS] },
    { pattern: `${base}/:id`, title: TASKS },
  ]),
  { pattern: '/tasks/legacy', title: TASKS },
  { pattern: '/tasks/new', title: TASKS },
  { pattern: '/tasks', title: TASKS },
  // Talents
  { pattern: '/talents/manage', title: ['Manage employees', ...TALENTS] },
  { pattern: '/talents/:id/edit', title: TALENTS },
  { pattern: '/talents/:id', title: TALENTS },
  { pattern: '/talents', title: TALENTS },
  // On/off-boarding
  { pattern: '/on-off-boarding/new', title: ['New process', ...BOARDING] },
  { pattern: '/on-off-boarding/:id', title: BOARDING },
  { pattern: '/on-off-boarding-templates', title: ['Process templates'] },
  { pattern: '/on-off-boarding', title: BOARDING },
  // Feedback
  { pattern: '/feedback/questionnaire-preview', title: ['Questionnaire preview', 'Feedback'] },
  { pattern: '/feedback', title: ['Feedback'] },
  // Integrations
  { pattern: '/integrations/linkedin/callback', title: ['LinkedIn', 'Integrations'] },
  { pattern: '/integrations', title: ['Integrations'] },
  // Admin and the rest of the staff app
  { pattern: '/admin/mass-email', title: ['Mass email'] },
  { pattern: '/dashboard', title: ['Dashboard'] },
  { pattern: '/organizations', title: ['Organizations'] },
  { pattern: '/customers', title: ['Customers'] },
  { pattern: '/agencies', title: ['Agencies'] },
  { pattern: '/settings', title: ['Settings'] },
  { pattern: '/reports', title: ['Reports'] },
  { pattern: '/payroll-hub', title: ['Payroll hub'] },
  { pattern: '/telegram-bot', title: ['Telegram bot'] },
  { pattern: '/users', title: ['Users'] },
  { pattern: '/devices', title: ['Devices'] },
  { pattern: '/activity-log', title: ['Activity log'] },
  { pattern: '/manual', title: ['Manual'] },
  { pattern: '/account', title: ['Account settings'] },
  { pattern: '/ai-integrations', title: ['AI integrations'] },
  { pattern: '/support-requests', title: ['Support requests'] },
  { pattern: '/performance-security', title: ['Performance & security'] },
  // Talent self-service portal
  { pattern: `${TALENT_PORTAL}/profile`, title: ['My profile'] },
  { pattern: `${TALENT_PORTAL}/feedback`, title: ['Feedback'] },
  { pattern: `${TALENT_PORTAL}/my-finance`, title: ['My finance'] },
  { pattern: `${TALENT_PORTAL}/monthly-invoices`, title: ['Monthly invoices'] },
  { pattern: `${TALENT_PORTAL}/hours-reporting`, title: ['Hours reporting'] },
  { pattern: `${TALENT_PORTAL}/account`, title: ['Account'] },
  { pattern: `${TALENT_PORTAL}/reset-password`, title: ['Reset password'] },
  // Customer portal
  { pattern: `${CUSTOMER_PORTAL}/login`, title: ['Customer login'] },
  { pattern: `${CUSTOMER_PORTAL}/set-password`, title: ['Set password', 'Customer portal'] },
  { pattern: `${CUSTOMER_PORTAL}/dashboard`, title: ['Dashboard', 'Customer portal'] },
  { pattern: `${CUSTOMER_PORTAL}/talents/:id`, title: ['Customer portal'] },
  // Public
  { pattern: '/login', title: ['Login'] },
  { pattern: '/reset-password', title: ['Reset password'] },
  { pattern: '/oauth/consent', title: ['Authorize access'] },
  { pattern: '/', title: ['Login'] },
];

// Breadcrumb labels for a path, most specific first; [] when the path is unknown.
export const sectionTitle = pathname => {
  const hit = SECTIONS.find(({ pattern }) => matchPath({ path: pattern, end: true }, pathname || ''));
  return hit ? hit.title : [];
};

const clip = value => (value.length > MAX_DETAIL ? `${value.slice(0, MAX_DETAIL - 1).trimEnd()}…` : value);

// "<detail> · <crumbs...> · COMS"; empty parts and a detail repeating the first crumb are dropped.
export const formatTitle = (detail, crumbs = []) => {
  const text = typeof detail === 'string' ? detail.trim().replace(/\s+/g, ' ') : '';
  const shown = text && text !== crumbs[0] ? clip(text) : '';
  return [shown, ...crumbs, APP_TITLE].filter(Boolean).join(SEPARATOR);
};
